import type { SpaceAddress } from "../types/space.types";

type SpaceState = {
  space: {
    isFetching: boolean;
    hasFetched: boolean;
    data?: SpaceAddress & {
      _id: string;
      cancellation_policy?: { name?: string };
      completion_percentage?: number;
      ownerId?: string;
      status?: string;
      title?: string;
      total?: number;
    };
    countryStatus: {
      isFetching: boolean;
      hasFetched: boolean;
      data?: { country?: string };
    };
  };
};

const selectSpaceIsFetching = (state: SpaceState) => state.space.isFetching;
const selectSpaceHasFetched = (state: SpaceState) => state.space.hasFetched;
const selectSpaceCompletionPercentage = (state: SpaceState) =>
  state.space.data?.completion_percentage;
const selectSpaceTotal = (state: SpaceState) => state.space.data?.total;

/** The space address already on file, empty for a space being created. */
const selectSpaceAddress = (state: SpaceState): SpaceAddress =>
  state.space?.data ?? {};

/**
 * Set once a host has listed a space, and while set the country field is read-only:
 * a second country requires a second account.
 */
const selectAccountCountry = (state: SpaceState) =>
  state.space?.countryStatus?.data?.country;

const selectSpaceId = (state: SpaceState) => state.space?.data?._id;
const selectSpaceOwnerId = (state: SpaceState) => state.space?.data?.ownerId;
const selectSpaceStatus = (state: SpaceState) => state.space?.data?.status;
const selectSpaceCountryStatusHasFetched = (state: SpaceState) =>
  Boolean(state.space?.countryStatus?.hasFetched);

export {
  selectAccountCountry,
  selectSpaceAddress,
  selectSpaceCountryStatusHasFetched,
  selectSpaceId,
  selectSpaceIsFetching,
  selectSpaceHasFetched,
  selectSpaceCompletionPercentage,
  selectSpaceOwnerId,
  selectSpaceStatus,
  selectSpaceTotal,
};

export type { SpaceState };
